define('apps/admin/views/license-product',[
        'njs!apps/admin/templates/includes/_license_product(params:tmpl=admin/main/includes/_license_product.html)',
    ], function(template) {
        'use strict';

        return Mn.ItemView.extend({

            "template": template,

            "tagName": "tr",

            "className": "comet-data-table__row",

        });
});

